import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-gostei_8053bf5f8e03d1ca46064778c5734718",
  "use": "ic-gostei_8053bf5f8e03d1ca46064778c5734718-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ic-gostei_8053bf5f8e03d1ca46064778c5734718\">\n    <path fill-rule=\"nonzero\" d=\"M17.35 24.24a2.01 2.01 0 0 1-2.69-.01l-.11-.1c-5.248-4.714-8.676-7.8-8.546-11.651A5.408 5.408 0 0 1 8.343 8.22 5.827 5.827 0 0 1 16 9.313a5.81 5.81 0 0 1 7.657-1.092 5.408 5.408 0 0 1 2.339 4.258c.14 3.85-3.299 6.937-8.547 11.67l-.1.09z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id